import { createCompassModalSwitcher } from "@/react/components/SettingsApp/CompassCompat/createCompassModalSwitcher";

import { ImageLinkModalComponent } from "./ImageLinkModalComponent";
import { ImageLinkModalUIKitComponent } from "./ImageLinkModalUIKitComponent";

export const useImageLinkModal = createCompassModalSwitcher(
  ImageLinkModalComponent,
  ImageLinkModalUIKitComponent,
);
